"use client";

import Link from "next/link";

export default function OrganisationsPage() {
  return (
    <main className="max-w-4xl mx-auto p-6 space-y-8">
      <h1 className="text-3xl font-bold text-amber-400 uppercase mb-6">
        FOR ORGANISATIONS
      </h1>

      <section>
        <h2 className="text-xl font-semibold text-amber-400 uppercase mb-2">
          LEADERSHIP VS. MANAGEMENT - WHY TRADITIONAL TRAINING ISN'T ENOUGH
        </h2>
        <p className="text-gray-300">
          Management training is common, but it usually focuses on policies, procedures, and team interaction.
          What it often misses is the personal development needed to create true leaders.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-amber-400 uppercase mb-2">
          WHAT IS LEADERSHIP?
        </h2>
        <p className="text-gray-300">
          Leadership is often defined by what leaders <em>do</em>, but rarely by what leadership <em>is</em>.
          Effective leaders have self-awareness, emotional intelligence, critical thinking skills, and the ability to
          reflect and learn from experience. These skills can't be taught through a slide deck or a computer-based
          course - they need practice.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-amber-400 uppercase mb-2">
          DEVELOPING FUTURE LEADERS - MENTORING FOR REAL-WORLD GROWTH
        </h2>
        <p className="text-gray-300">
          Our mentoring approach helps individuals develop these traits by actively engaging them in the reflection,
          problem-solving, and decision-making involved in their day-to-day roles - not just the theory. We meet
          people where they are and make leadership development practical, personal, and relevant.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-amber-400 uppercase mb-2">
          BUSINESS BENEFITS - BETTER LEADERSHIP, HAPPIER TEAMS
        </h2>
        <p className="text-gray-300">
          Organisations working with Flightpath Mentoring see: - Improved day-to-day leadership, with better
          direction and less conflict - Stronger succession planning for future leaders - Better staff retention and
          reduced recruitment costs. Our programmes pay for themselves by upskilling your people across the organisation.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-amber-400 uppercase mb-2">
          SPEAKING & SEMINARS - LEADERSHIP TALKS WITH IMPACT
        </h2>
        <p className="text-gray-300">
          Looking for something different for your company event? Our interactive seminars combine motivational
          content with real stories from the flight deck - inspiring, memorable, and practical. We also deliver
          engaging sessions for schools, clubs, and youth organisations.
        </p>
      </section>

      {/* CTA Line */}
      <section className="pt-8">
        <p className="text-cyan-400 font-semibold">
          <Link
            href="/contact"
            className="hover:underline hover:text-green-400 transition-colors"
          >
            Contact us
          </Link>{" "}
          now to start your journey...
        </p>
      </section>
    </main>
  );
}
